import { useEffect, useState } from "react";
import { auth } from "../api/auth";

/**
 * This needs to happen before any request
 */
export function useAutoLogin() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loginUser = async () => {
      try {
        setIsLoading(true);
        await auth.login();
      } finally {
        setIsLoading(false);
      }
    };
    loginUser();
  }, []);

  return isLoading;
}